import Vue from 'vue';

import CONFIG from "../../config";
Vue.prototype.$config = CONFIG;

import utils from "./utils.js";
Vue.prototype.$utils = utils;

import http from './http.js';
Vue.prototype.$http = http;

/**
 * 判断当前登录用户是否拥有某一个权限代码，有则返回true  无则返回false
 * @param {Object} privilegeCode 权限代码
 */
Vue.prototype.$has_privlege = function(privilegeCode){
	if(this.$store.state.privilegeCodes){
		return this.$store.state.privilegeCodes.includes(privilegeCode);
	}
	else{
		return false;
	}
}

/**
 * 判断当前登录用户的角色是否是指定的角色，是则返回true  无则返回false
 * @param {Object} role 角色
 */
Vue.prototype.$has_role = function(roleCode){
	console.log('-----$has_role roleCode:',roleCode);
	console.log('-----$has_role this.$store.state.user.js:',this.$store.state.user.js);
	if(this.$store.state.user.js){
		return this.$store.state.user.js == roleCode;
	}
	else{
		return false;
	}
}

import 'ztree';
import 'ztree/css/metroStyle/metroStyle.css';

import './message.js';

//Table插件
import BootstrapTable from '@/components/table';
Vue.use(BootstrapTable);

//时间日期插件
import DateTimePicker from '@/components/date-picker';
Vue.use(DateTimePicker);

//下拉搜索框
import BootstrapCombobox from '@/components/combox';
Vue.use(BootstrapCombobox);

//对话框
import BootstrapDialog from '@/components/dialog';
Vue.use(BootstrapDialog);

//富文本编辑器
import CkEditor from '@/components/ckeditor';
Vue.use(CkEditor);

//课件上传插件
import CoursewareUpload from '@/components/courseware';
Vue.use(CoursewareUpload);

//图片上传插件
import ImageUpload from '@/components/imageupload';
Vue.use(ImageUpload);

//文件上传插件
import FileUpload from '@/components/fileupload';
Vue.use(FileUpload);

import Treeselect from '@/components/treeselect';
Vue.use(Treeselect);

//照片预览全局
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);

//照片预览
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
let options = {
  fullscreenEl: false,
}
Vue.use(preview, options);

//cookie插件
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

//表单校验
import '@/components/validator';


